export const getGroupedOptionsFromTreeByPredicate = (roots, predicate, entitiesMap) => {
  const groupedOptions = [];
  roots.forEach(root => {
    if (predicate(root)) {
      const childrenIds = root.childrenIds;
      if (childrenIds) {
        const children = childrenIds.map(childId => entitiesMap[childId]).filter(predicate);
        if (children.length) {
          groupedOptions.push([root.title, children]);
        }
      }
    }
  });
  return groupedOptions;
};
